var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DropOffAreaFacet, MulticastDelegate1 } from "flavr-common";
import { OnEnterContactsMessage, OnLeaveContactsMessage } from "@messages/selection";
import { FacetRemoveHandler, FacetHandler, ModelEventHandler, MessageHandler, ModelEventType, Service } from "@modules/module";
export class DropOffAreaManager extends Service {
    constructor(connection) {
        super(connection);
        this.dropOffAreas = new Map();
        this.dropOffModels = new Map();
        this.allContacts = new Set();
        this.validContacts = new Set();
        this.onEnterDropOffArea = new MulticastDelegate1();
        this.onLeaveDropOffArea = new MulticastDelegate1();
        this.onMoveInsideDropOffArea = new MulticastDelegate1();
    }
    /// Manage models to check against ///
    addModel(modelUID, layers) {
        this.dropOffModels.set(modelUID, {
            uid: modelUID,
            layers
        });
        this.updateValidContacts();
    }
    removeModel(modelUID) {
        this.dropOffModels.delete(modelUID);
        this.removeValidContactsWith(modelUID);
    }
    /// Manage drop off areas ///
    getDropOffAreaTargetUID(dropOffAreaUID) {
        var _a;
        return (_a = this.dropOffAreas.get(dropOffAreaUID)) === null || _a === void 0 ? void 0 : _a.target;
    }
    getDestinationPositionUID(dropOffAreaUID, pickupUID) {
        var _a;
        const area = this.dropOffAreas.get(dropOffAreaUID);
        return (_a = area === null || area === void 0 ? void 0 : area.destinationTargets.find(t => t.pickupUid === pickupUID)) === null || _a === void 0 ? void 0 : _a.positionUid;
    }
    isInsideDropOffArea(modelUID, dropOffAreaUID) {
        return this.hasValidContact(modelUID, dropOffAreaUID);
    }
    refreshContacts() {
        this.updateValidContacts();
    }
    /// Message handlers ///
    handleDropOffAreaFacet(uid, facet, _meta) {
        var _a;
        this.createDropOffArea(uid, facet.dropOffTargetUid, facet.dropOffLayer, (_a = facet.destinationTargets) !== null && _a !== void 0 ? _a : []);
    }
    handleRemoveDropOffAreaFacet(uid, _facetType) {
        this.removeDropOffArea(uid);
    }
    handleOnEnterContactsMessage(msg, _meta) {
        this.addToAllContacts(msg.contacts);
        for (const contact of this.filterValidContactCandidates(msg.contacts, true)) {
            // Entry is already present
            if (this.hasValidContact(contact.modelUID, contact.dropOffAreaUID))
                continue;
            const validContact = { modelUID: contact.modelUID, dropOffAreaUID: contact.dropOffAreaUID };
            this.validContacts.add(validContact);
            this.onEnterDropOffArea.invoke(validContact);
        }
    }
    handleOnLeaveContactsMessage(msg, _meta) {
        return __awaiter(this, void 0, void 0, function* () {
            this.removeFromAllContacts(msg.contacts);
            for (const contact of this.filterValidContactCandidates(msg.contacts, false)) {
                // Entry not present
                const validContact = this.getValidContact(contact.modelUID, contact.dropOffAreaUID);
                if (validContact === undefined)
                    continue;
                this.validContacts.delete(validContact);
                this.onLeaveDropOffArea.invoke(validContact);
            }
        });
    }
    handleModelTransformEvent(model, _localTransform) {
        for (const contact of this.findValidContactsWith(model.getUID())) {
            this.onMoveInsideDropOffArea.invoke(contact);
        }
    }
    /// All contacts helper methods ///
    addToAllContacts(contactInfos) {
        for (const contact of contactInfos) {
            this.allContacts.add(contact);
        }
    }
    removeFromAllContacts(contactInfos) {
        for (const contactInfo of contactInfos) {
            const uidA = contactInfo.collisionShapeAUID;
            const uidB = contactInfo.collisionShapeBUID;
            const contact = this.findInAllContacts(uidA, uidB);
            if (contact !== undefined)
                this.allContacts.delete(contact);
        }
    }
    findInAllContacts(uidA, uidB) {
        for (const contact of this.allContacts) {
            if ((contact.collisionShapeAUID === uidA && contact.collisionShapeBUID === uidB) ||
                (contact.collisionShapeAUID === uidB && contact.collisionShapeBUID === uidA)) {
                return contact;
            }
        }
        return undefined;
    }
    /// Drop off area helper methods ///
    createDropOffArea(dropOffAreaUID, targetUID, dropOffLayer, destinationTargets) {
        this.dropOffAreas.set(dropOffAreaUID, {
            uid: dropOffAreaUID,
            target: targetUID,
            layer: dropOffLayer,
            destinationTargets
        });
    }
    removeDropOffArea(dropOffAreaUID) {
        this.dropOffAreas.delete(dropOffAreaUID);
    }
    /// Valid contact helper methods ///
    getValidContact(modelUID, dropOffAreaUID) {
        for (const contact of this.validContacts) {
            if (contact.modelUID === modelUID && contact.dropOffAreaUID === dropOffAreaUID)
                return contact;
        }
        return undefined;
    }
    findValidContactsWith(uid) {
        const foundContacts = [];
        for (const contact of this.validContacts) {
            if (contact.modelUID === uid || contact.dropOffAreaUID === uid)
                foundContacts.push(contact);
        }
        return foundContacts;
    }
    updateValidContacts() {
        const allContactsList = Array.from(this.allContacts);
        const candidates = this.filterValidContactCandidates(allContactsList, true);
        for (const contact of candidates) {
            // Duplicate entries would survive the leave event and keep the preview alive
            if (this.hasValidContact(contact.modelUID, contact.dropOffAreaUID))
                continue;
            this.validContacts.add({ modelUID: contact.modelUID, dropOffAreaUID: contact.dropOffAreaUID });
            this.onEnterDropOffArea.invoke(contact);
        }
    }
    removeValidContactsWith(uid) {
        for (const contact of this.findValidContactsWith(uid)) {
            this.validContacts.delete(contact);
            this.onLeaveDropOffArea.invoke(contact);
        }
    }
    hasValidContact(modelUID, dropOffAreaUID) {
        return this.getValidContact(modelUID, dropOffAreaUID) !== undefined;
    }
    filterValidContactCandidates(contacts, layersHaveToMatch) {
        var _a, _b, _c;
        const foundEntries = [];
        for (const contact of contacts) {
            const bodyA = contact.collisionShapeAUID;
            const bodyB = contact.collisionShapeBUID;
            let entry;
            if (this.dropOffModels.has(bodyA) && this.dropOffAreas.has(bodyB)) {
                entry = {
                    modelUID: bodyA,
                    dropOffAreaUID: bodyB,
                };
            }
            else if (this.dropOffModels.has(bodyB) && this.dropOffAreas.has(bodyA)) {
                entry = {
                    modelUID: bodyB,
                    dropOffAreaUID: bodyA,
                };
            }
            if (entry === undefined)
                continue;
            // If specified, check if layers match
            const modelLayers = (_b = (_a = this.dropOffModels.get(entry.modelUID)) === null || _a === void 0 ? void 0 : _a.layers) !== null && _b !== void 0 ? _b : [];
            const dropOffLayer = (_c = this.dropOffAreas.get(entry.dropOffAreaUID)) === null || _c === void 0 ? void 0 : _c.layer;
            if (layersHaveToMatch && dropOffLayer !== undefined && !modelLayers.includes(dropOffLayer))
                continue;
            foundEntries.push(entry);
        }
        return foundEntries;
    }
}
__decorate([
    FacetHandler(DropOffAreaFacet)
], DropOffAreaManager.prototype, "handleDropOffAreaFacet", null);
__decorate([
    FacetRemoveHandler(DropOffAreaFacet)
], DropOffAreaManager.prototype, "handleRemoveDropOffAreaFacet", null);
__decorate([
    MessageHandler(OnEnterContactsMessage)
], DropOffAreaManager.prototype, "handleOnEnterContactsMessage", null);
__decorate([
    MessageHandler(OnLeaveContactsMessage)
], DropOffAreaManager.prototype, "handleOnLeaveContactsMessage", null);
__decorate([
    ModelEventHandler(ModelEventType.TRANSFORM_UPDATED)
], DropOffAreaManager.prototype, "handleModelTransformEvent", null);
